import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const saveSupplierConfigData = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER_TO_DO.SAVE_CONFIG_DATA}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierConfigData = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_TO_DO.GET_CONFIG_DATA}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierDetailData = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_TO_DO.GET_SUPPLIER_DETAIL_DATA}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierTodoListService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TODO_LIST.GET_TODO_LIST}/${data.type}`, {
      params: data,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const saveSupplierDetailData = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER_TO_DO.GET_SUPPLIER_DETAIL_DATA}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllComponentSubType = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER_TO_DO.GET_COMPONENT_SUB_TYPE}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getExistingSuggestion = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPLIER_SUGGESTION.GET_EXISTING_SUGGESTION}`, data);
  } catch (error) {
    console.log(error);
    throw error;
  }
};
